import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { React, useState, useEffect, useContext, useRef } from 'react';
import Undo_Redo from "../../../components/ui/undo_redo.js";
import * as menu from "../../../assets/menus/menu.js";
import UserContext from '../../../components/User_Context.js';
import { useParams } from 'react-router-dom';
import waiting from "../../../assets/images/waiting.svg";
import * as api from "../../../api/apiConnector.js";
import WebViewer from '@pdftron/webviewer';
import * as uploadManager from "../../../components/ui/fileupload.js";
import { useTranslation } from 'react-i18next';
import * as breadcrumb from "../../../components/ui/breadcrumb.js";


const Edit_File_Screen = (params) => {
    const [value, setValue] = useState(null);
    const [editor, setEditor] = useState(null);
    const { currentUser } = useContext(UserContext);
    const { id = null } = useParams();
    const { t } = useTranslation('labels');
    const [fileInfo, setFileInfo] = useState(null);
    let undo_redo = null;

    const _get_data = async () => {
        const edit_result = await api.sendMessage("dms/getFileInfo", {
            user: currentUser(),
            body: {
                id
            }
        });

        
        setFileInfo(edit_result.file);

        setValue({
            file: edit_result.file
        });

        return edit_result.file;
    }

    const upload = async (params) => {
        params.user = currentUser();
        uploadManager.fileUpload(params);
    }

    const _save = async () => {
        const { documentViewer, annotationManager } = editor;

        const doc = documentViewer.getDocument();
        const xfdfString = await annotationManager.exportAnnotations();

        const data = await doc.getFileData({ xfdfString });
        const arr = new Uint8Array(data);

        value.file.Name = doc.filename;
        setValue({ file: value.file });

        const _file = new File([arr], value.file.Name, { type: value.file.MimeType });
        _file["__dms"] = {
            file: value.file
        }

        upload({
            files: [_file], parentId: value.file.ParentId, onFileAdded: (files) => {
            }
        });
    }

    // const setBreadCrumb = (params) => {
    //     var path = [{
    //         link: "/",
    //         name: t('home', { ns: 'labels' })
    //     },
    //     {
    //         link: "dms",
    //         name: t('dms', { ns: 'labels' })
    //     },
 
    //     ];
    //     breadcrumb.set(path);
    // }

    const getFolder = async (parentId) => {
        var result = await api.sendMessage("dms/getFolder", {
          user: currentUser(),
          body: {
            id: parentId,
          },
        });
    
        result.content.path = [];
    
        if (result.content) {
          let _path = await api.sendMessage("dms/getFolderPath", {
            user: currentUser(),
            body: {
              id: parentId,
            },
          });
    
          if (_path?.folders) {
            result.content.path = _path.folders.map((f) => {
              return {
                name: f.Name,
                link: `/dms/${f.Id}`,
              };
            });
          }
        }
    
        result.content.path = [
          {
            link: "/dms",
            name: "DMS",
          },
        ].concat(result.content.path);
    
        result.content.path = [
          {
            link: "/",
            name: "Home",
          },
        ].concat(result.content.path);
    
        return result?.content;
      };
    

    useEffect(async () => {
        (async () => {
            menu.write({ user: currentUser() });
            const file = await _get_data();
            if (file && file.ParentId) {
                let _content = await getFolder(file.ParentId);
                breadcrumb.set(_content.path);
            }
        })();
    }, []);

    useEffect(() => {
        if (value) _initWebViewer();
        (async () => {

        })();

    }, [value]);

    const viewer = useRef(null);

    const _initWebViewer = () => {
        if (!viewer.current || editor) return;
        WebViewer.WebComponent(
            {
                path: '/webviewer/lib',
                licenseKey: process.env.REACT_APP_APRYSE_LICENSE_KEY,
                enableOfficeEditing: true,
                //initialDoc: "http://localhost:3000/dms/edit/get/A7B03307-95B8-4270-855B-13375D5A355C",                
                //extension: 'docx',
            },
            viewer.current,
        ).then((instance) => {
            const { documentViewer } = instance.Core;
            //const arr = new Uint8Array(value.data.data);
            //const blob = new Blob([arr], { type: value.file.MimeType });
            // instance.UI.loadDocument(blob, {
            //     filename: value.file.Name,
            //     extension: 'docx'
            // });
            const fileExtension = value.file.Name.split(".").pop().toLowerCase();

            instance.UI.setHeaderItems(header => {
                header.push({
                  type: 'actionButton',
                  img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M284 224.8a34.1 34.1 0 1 0 34.3 34.1A34.2 34.2 0 0 0 284 224.8zm-110.5 0a34.1 34.1 0 1 0 34.3 34.1A34.2 34.2 0 0 0 173.6 224.8zm220.9 0a34.1 34.1 0 1 0 34.3 34.1A34.2 34.2 0 0 0 394.5 224.8zm153.8-55.3c-15.5-24.2-37.3-45.6-64.7-63.6-52.9-34.8-122.4-54-195.7-54a406 406 0 0 0 -72 6.4 238.5 238.5 0 0 0 -49.5-36.6C99.7-11.7 40.9 .7 11.1 11.4A14.3 14.3 0 0 0 5.6 34.8C26.5 56.5 61.2 99.3 52.7 138.3c-33.1 33.9-51.1 74.8-51.1 117.3 0 43.4 18 84.2 51.1 118.1 8.5 39-26.2 81.8-47.1 103.5a14.3 14.3 0 0 0 5.6 23.3c29.7 10.7 88.5 23.1 155.3-10.2a238.7 238.7 0 0 0 49.5-36.6A406 406 0 0 0 288 460.1c73.3 0 142.8-19.2 195.7-54 27.4-18 49.1-39.4 64.7-63.6 17.3-26.9 26.1-55.9 26.1-86.1C574.4 225.4 565.6 196.4 548.3 169.5zM285 409.9a345.7 345.7 0 0 1 -89.4-11.5l-20.1 19.4a184.4 184.4 0 0 1 -37.1 27.6 145.8 145.8 0 0 1 -52.5 14.9c1-1.8 1.9-3.6 2.8-5.4q30.3-55.7 16.3-100.1c-33-26-52.8-59.2-52.8-95.4 0-83.1 104.3-150.5 232.8-150.5s232.9 67.4 232.9 150.5C517.9 342.5 413.6 409.9 285 409.9z"/></svg>', // Icona del tuo agente AI
                });
            });
            instance.UI.enableFeatures([instance.UI.Feature.ContentEdit]);

            instance.UI.loadDocument(`${api.get_url(`dms/edit/get/${value.file.Id}`)}`, {
                filename: value.file.Name,
                extension: fileExtension,
                customHeaders: {
                    Authorization: currentUser().token
                }
            });

            setEditor(instance.Core);

            documentViewer.addEventListener('documentLoaded', () => {
                // perform document operations

                console.log(instance.Core);
            });

            documentViewer.addEventListener('toolUpdated', (e) => {
                // perform document operations
                console.log(e);
            });

            Object.keys(instance.UI.Events).forEach(key => {
                const _eventName = instance.UI.Events[key];
                if (/./.test(_eventName)) {
                    window.addEventListener(_eventName, event => {
                        console.log(key, event)
                    })
                }
            })
        });
    }

    const _editor = () => {
        return (<div className="webviewer" ref={viewer} style={{ height: "100%" }}></div>);
    }

    const _edit_mode = (params) => {
        return (
            <>
                <div className="page-titles">
                    <ol className="breadcrumb">

                    </ol>
                    <div>
                        <a className="text-primary fs-13" onClick={(e) => {
                            _save();
                        }} role="button" title={t('saveData', { ns: 'labels' })}><i className="fa-solid fa-floppy-disk fa-2x"></i></a>
                    </div>
                </div>

                <div className="container-fluid" style={{ height: 'calc(100vh - 150px)' }}>
                    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                        {_editor()}
                    </div>
                </div>
            </>
        );
    }

    const _render = () => {
        return (_edit_mode());
    }

    return (<>
        {_render()}
    </>)
}

export { Edit_File_Screen }